export default __webpack_public_path__ + "static/media/home-restaurant-img-07.6d89e115.jpg";